module.exports = "https://static.moomoo.com/components/lottery2/images/bg.2d244d4692.png";